import { render, staticRenderFns } from "./AddressItem.vue?vue&type=template&id=b7f82714&"
import script from "./AddressItem.vue?vue&type=script&lang=ts&"
export * from "./AddressItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports